import {Action} from "redux";
import {CategoryId} from "./data";

export type CategoryManagerAction = SetCategoryCheckboxAction | UnSetCategoryCheckboxAction

type SetCategoryCheckboxAction = {
	type: "set category checkbox"
	value: CategoryId
}

type UnSetCategoryCheckboxAction = {
	type: "unset category checkbox"
	value: CategoryId
}

export type CategoryManagerActionWrapper = {
	type: "category manager action"
	action: CategoryManagerAction
}

export const isCategoryManagerAction = (a: Action): a is CategoryManagerActionWrapper => {
	return a.type == "category manager action"
}



// WEBPACK FOOTER //
// ./src/lib/category-manager/actions.ts